"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createLampElement_1 = __importDefault(require("../helps/createLampElement"));
const data_start_1 = require("../../data-start");
const addLamps_1 = __importDefault(require("../helps/addLamps"));
const deleteLamps_1 = __importDefault(require("./deleteLamps"));
const createButtonStillLamps_1 = __importDefault(require("./createButtonStillLamps"));
const createButtonStillLamps_2 = require("./createButtonStillLamps");
const addTotalFindLampOnPage_1 = __importDefault(require("../helps/addTotalFindLampOnPage"));
const showImg_1 = __importDefault(require("./showImg"));
//= create
const create = (arrLamps) => {
    try {
        (0, deleteLamps_1.default)();
        (0, addTotalFindLampOnPage_1.default)(arrLamps.length);
        (0, createLampElement_1.default)(arrLamps, 0, data_start_1.elementsOnPage);
        (0, createButtonStillLamps_1.default)(createButtonStillLamps_2.ComandButtonLamp.Delete);
        if (arrLamps.length > 12) {
            (0, createButtonStillLamps_1.default)(createButtonStillLamps_2.ComandButtonLamp.Create);
            const addButton = document.querySelector('#button-add-lamps');
            addButton?.addEventListener('click', listener);
        }
        else {
            (0, createButtonStillLamps_1.default)(createButtonStillLamps_2.ComandButtonLamp.Delete);
        }
        function listener() {
            (0, addLamps_1.default)(arrLamps, data_start_1.elementsOnPage);
        }
        //* показ изображения лампы во весь экран
        (0, showImg_1.default)();
    }
    catch (error) {
        console.log('Error in function create >>> ', error);
    }
};
exports.default = create;
